import React, { useCallback, useState } from "react";
import MindsetSelection from "./MindsetSelection";
import { useSelector } from "react-redux";
import { dispatch } from "../../../redux/store";
import { setMindset as setMindsetAction } from "../../../redux/actions/user";
import Button from "../../input/button";
import { setOverlayVisible } from "../../../redux/actions/overlay";
import useUserAPIClient from "../../../api/user/hooks/useUserAPIClient";

const MindsetOverlay = () => {
  const { mindset } = useSelector((state) => state.user);
  const { setMindset } = useUserAPIClient();
  const [initialMindset, _] = useState(mindset);
  const [saving, setSaving] = useState(false);

  const onUpdateMindset = (updatedMindset) => {
    dispatch(setMindsetAction(updatedMindset));
  };

  const onAcceptClick = useCallback(async () => {
    setSaving(true);
    await setMindset(mindset);
    setSaving(false);
    dispatch(setOverlayVisible({ visible: false }));
  }, [mindset]);

  const onCancelClick = () => {
    dispatch(setMindsetAction(initialMindset));
    dispatch(setOverlayVisible({ visible: false }));
  };

  return (
    <div className="mindset-overlay">
      <MindsetSelection
        onUpdateMindset={onUpdateMindset}
        initialMindset={mindset}
      />
      <div className="mindset-overlay_button-container">
        <Button
          text="Cancel"
          color="red"
          icon="close"
          onClick={onCancelClick}
          disabled={saving}
        />
        <Button
          text="Accept"
          color="green"
          icon="tick"
          onClick={onAcceptClick}
          loading={saving}
        />
      </div>
    </div>
  );
};

export default MindsetOverlay;
